import { apiDelete, apiGet, apiPut } from './api';

export type ExerciseRow = {
  _id: string;
  title?: string;
  code?: string;
  description?: string;
  status?: string;
  isPublic?: boolean;
  passing_threshold?: number;
  questions?: unknown[];
  author?: { email?: string; nickname?: string };
  totalAttempts?: number;
  averageScore?: number;
  updatedAt?: string;
};

export async function listExercises(params: Record<string, string | number> = {}) {
  const qs = new URLSearchParams(
    Object.entries(params).map(([k, v]) => [k, String(v)])
  ).toString();
  return apiGet<{ success: boolean; data?: { exercises: ExerciseRow[] }; message?: string }>(
    `/api/v1/exercises${qs ? `?${qs}` : ''}`
  );
}

export async function updateExercise(id: string, body: Record<string, unknown>) {
  return apiPut(`/api/v1/exercises/${id}`, body);
}

export async function deleteExercise(id: string) {
  return apiDelete(`/api/v1/exercises/${id}`);
}
